import React, { RefObject, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

// Text

// import img from "next/image";
import { MDBCheckbox } from "mdb-react-ui-kit";
import Popup from "reactjs-popup";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Header from "./components/header/header";
import Layout from "./components/layout/Layout";

import {
  faChevronRight,
  faClose,
  faMinus,
  faPhone,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import ClinicGalleryOne from "./components/clinic_gallery_1/clinicGalleryOne";
import ClinicGalleryTwo from "./components/clinic_gallery_2/clinicGalleryTwo";
import Gallery from "./components/gallery/gallery";
import Mheader from "./components/header/m-header";
// import Review from "./components/reviews/Review";
import Footer from "./components/footer/Footer";
import PcGallery from "./components/gallery/pc_gallery";
import ReviewGallery from "./components/reviews/ReviewGallery";
// import GalleryExample from "./components/GalleryExample";
import { keyframes } from "@emotion/react";
import { Bounce, Fade, Reveal } from "react-awesome-reveal";
import ReviewGalleryDesktop from "./components/reviews/ReviewGalleryDesktop";
import "./styles/global.css";
import "./styles/main/main.css";

// import { link } from "fs";

import emailjs from "@emailjs/browser";

interface Tabprops {
  number: string;
  text: string;
  goldText?: string;
}

interface ExpandedService {
  service_text: string;
  link_text: string;
  link_text_2?: string;
  link_text_3?: string;
  link_text_4?: string;
  link_text_5?: string;
  link_text_6?: string;
  link_text_7?: string;
  link_text_8?: string;
  link_text_9?: string;
  href: string;
  href_2?: any;
  href_3?: any;
  openModal?: any;
  href_4?: any;
  href_5?: any;
  href_6?: any;
  href_7?: any;
  href_8?: any;
  href_9?: any;
}

interface ReviewTabProps {
  date: string;
  name: string;
  paragraph: string;
}

// Page Photos
const mainPhoto = require("./assets/main_photo.webp");
const whatsapp = require("./assets/whatsapp.webp");
const mainPC = require("./assets/main_pc.webp");
const pavel = require("./assets/pavel.png");
const pavelPC = require("./assets/pavel_pc.png");
const bulb: string = require("./assets/bulb.svg").default;
const featuresPhoto = require("./assets/features_photo.png");
const featuresPhotoPc = require("./assets/features_image.webp");
const toothIcon: string = require("./assets/tooth_icon.svg").default;
const chairIcon: string = require("./assets/chairs_icon.svg").default;
const galleryOnePic = require("./assets/gallery_one_pic.webp");
const galleryTwoPic = require("./assets/gallery_two_pic.webp");
const logoMobile: string = require("./assets/logo_mob.svg").default;
const servicesButton: string = require("./assets/service_button.svg").default;

// Doctors
const doctorOne = require("./assets/1.webp");
const doctorTwo = require("./assets/karen_pc.webp");
const doctorThree = require("./assets/3.webp");
const doctorFour = require("./assets/islam_pc.webp");
const doctorFive = require("./assets/arsen.webp");
const doctorSix = require("./assets/tatyana_pc.webp");
const doctorSeven = require("./assets/orthoped_pc.webp");
const doctorEight = require("./assets/marina_pc.webp");
const doctorNine = require("./assets/karen_pc.webp");
const doctorTen = require("./assets/yana_pc.webp");
const doctorEleven = require("./assets/sadiga.webp");

// Gallery
const galleryTwoPicture = require("./assets/gallery_c02.webp");
const galleryThreePicture = require("./assets/gallery_c03.webp");
const galleryFourPicture = require("./assets/gallery_c04.webp");
const galleryFivePicture = require("./assets/gallery_c05.webp");

const doctorOneMob = require("./assets/01.webp");
const doctorTwoMob = require("./assets/02.webp");
const doctorThreeMob = require("./assets/03.webp");
const doctorFourMob = require("./assets/islam_mob.webp");
const doctorFiveMob = require("./assets/elena_mob.webp");
const doctorSixMob = require("./assets/tatyana_mob.webp");
const doctorSevenMob = require("./assets/orthoped_mob.webp");
const doctorEightMob = require("./assets/karen_mob.webp");
const doctorNineMob = require("./assets/marina_mob.webp");
const doctorTenMob = require("./assets/yana_mob.webp");
const doctorElevenMob = require("./assets/sadiga_mob.webp");

const gallery02 = require("./assets/galleryS_02.webp");
const gallery03 = require("./assets/galleryS_03.webp");
const gallery04 = require("./assets/galleryS_04.webp");
const gallery05 = require("./assets/galleryS_05.webp");
const gallery06 = require("./assets/galleryS_06.webp");
const gallery07 = require("./assets/galleryS_07.webp");

// Gallery Photos
const galleryOne = require("./assets/gallery01.webp");
const galleryTwo = require("./assets/gallery02.webp");
const galleryThree = require("./assets/gallery03.webp");
const galleryFour = require("./assets/gallery04.webp");
const galleryFive = require("./assets/gallery05.webp");

const formImage = require("./assets/example_modal.png");
const pavelGallery = require("./assets/pavel_gallery.webp");
const modalImage = require("./assets/example_modal.webp");
const pavelGalleryPc = require("./assets/pavel_pc.webp");

const ReviewTab: React.FC<ReviewTabProps> = (props) => {
  return (
    <div className="review-tab">
      <div className="review-content">
        <div className="review-date">
          <span className="date">{props.date}</span>
          <div className="screenshot-container">
            <span className="screenshot">Скриншот</span>
          </div>
        </div>
        <div className="main-content">
          <h5 className="review-name">{props.name}</h5>
          <p className="review-paragraph">{props.paragraph}</p>
          <a href="" className="full">
            Читать полностью
          </a>
        </div>
      </div>
    </div>
  );
};

const ExpandedTab: React.FC<ExpandedService> = (props) => {
  return (
    <div className="expanded-container">
      <div className="text_divider">
        <div className="divider"></div>
        <div className="row_text">
          <span className="paragraph">Описание</span>
          <Link className="golden-link" to="/prices">
            Цены
          </Link>
        </div>
      </div>
      <button className="golden-button" onClick={props.openModal}>
        Запись на прием
      </button>
      <div className="text_divider">
        <div className="divider"></div>
        <div className="row_text">
          <span className="paragraph">{props.service_text}</span>
        </div>
      </div>
      <div className="links-container">
        <Link to={props.href} className="golden-link">
          {props.link_text}
        </Link>
        <Link to={props.href_2} className="golden-link">
          {props.link_text_2}
        </Link>
        <Link to={props.href_3} className="golden-link">
          {props.link_text_3}
        </Link>
        <Link to={props.href_4} className="golden-link">
          {props.link_text_4}
        </Link>
        <Link to={props.href_5} className="golden-link">
          {props.link_text_5}
        </Link>
        <Link to={props.href_6} className="golden-link">
          {props.link_text_6}
        </Link>
        <Link to={props.href_7} className="golden-link">
          {props.link_text_7}
        </Link>
        <Link to={props.href_8} className="golden-link">
          {props.link_text_8}
        </Link>
        <Link to={props.href_9} className="golden-link">
          {props.link_text_9}
        </Link>
      </div>
    </div>
  );
};

const FeatureTab: React.FC<Tabprops> = (props) => {
  return (
    <div className="feature-tab">
      <span className="number">{props.number}</span>
      <p className="paragraph">{props.text}</p>
      <p className="gold-text">{props.goldText}</p>
    </div>
  );
};

const FeatureLong: React.FC<Tabprops> = (props) => {
  return (
    <div className="feature-tab-long">
      <span className="number">{props.number}</span>
      <p
        className="paragraph-goldz"
        style={{
          color: "#E8CB6C",
          marginLeft: "clamp(8px,3.73824vw,32px)",
          marginTop: "clamp(13px,6.07464vw,52px)",
          fontSize: "clamp(8px,3.73824vw,32px)",
        }}
      >
        {props.text}
      </p>
    </div>
  );
};

type Swiper = any;

export default function HomePage() {
  const navigate = useNavigate();

  const [thankYou, setThankYou] = useState(false);
  const [isToothHealingOpened, setToothHealingOpen] = useState(true);
  const [isToothHealOpened, setToothHealOpen] = useState(false);
  const [isWhiteningOpened, setWhiteningOpen] = useState(false);
  const [isMouthHygieneOpened, setMouthHygieneOpen] = useState(false);
  const [isHealingInSleepOpened, setHealingInSleepOpen] = useState(false);
  const [isSurgeryOpened, setSurgeryOpened] = useState(false);
  const [isVinirsOpened, setVinirsOpen] = useState(false);
  const [isParodontHealingOpened, setParodontHealingOpen] = useState(false);
  const [isProthesisOpened, setProthesisOpen] = useState(false);
  const [isTeethSleepOpened, setTeethHealSleepOpened] = useState(false);
  const [isDiagnosisOpened, setDiagnosisOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const swiperRef = React.useRef<Swiper | null>(null);

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [bookDate, setBookDate] = useState("");
  const [bookTime, setBookTime] = useState("");
  const [visitGoal, setVisitGoal] = useState("");
  const [comment, setComment] = useState("");

  const form: RefObject<HTMLDivElement> = useRef(null);
  const phoneForm = useRef<HTMLFormElement>(null);

  function sendEmail(e: any) {
    e.preventDefault();
    setFullName("");
    setPhoneNumber("");
    setServiceName("");
    setDoctorName("");
    setServiceName("");

    emailjs
      .sendForm(
        "service_kwh5orp",
        "template_5kdc5wu",
        e.target,
        "b-K7bdT7JW4cqcN4y"
      )
      .then((res) => {
        setThankYou(true);
        console.log("SUCCESS");
      })
      .catch((err) => console.log(err));
  }

  function sendPhoneRequest(e: any) {
    e.preventDefault();
    setFullName("");
    setPhoneNumber("");

    emailjs
      .sendForm(
        "service_kwh5orp",
        "template_rgnaux5",
        e.target,
        "b-K7bdT7JW4cqcN4y"
      )
      .then((res) => {
        setThankYou(true);
        console.log("SUCCESS");
      })
      .catch((err) => console.log(err));
  }

  const toothHealingExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(true);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setSurgeryOpened(false);

    setTeethHealSleepOpened(false);
  };

  const toothHealingExpansion2 = () => {
    setToothHealingOpen(false);
    setToothHealOpen(true);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setTeethHealSleepOpened(false);
    setSurgeryOpened(false);
  };

  const whiteningExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(!isWhiteningOpened);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setSurgeryOpened(false);

    setDiagnosisOpen(false);
    setTeethHealSleepOpened(false);
  };

  const mouthHygieneExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(!isMouthHygieneOpened);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setTeethHealSleepOpened(false);
    setSurgeryOpened(false);
  };

  const healingInSleepExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(!isHealingInSleepOpened);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setSurgeryOpened(false);

    setDiagnosisOpen(false);
  };

  const surgeryExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setSurgeryOpened(!isSurgeryOpened);
    setParodontHealingOpen(false);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setHealingInSleepOpen(false);
    setDiagnosisOpen(false);
  };

  const parodontHealthExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(!isParodontHealingOpened);
    setVinirsOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setTeethHealSleepOpened(false);
    setSurgeryOpened(false);
  };

  const vinirExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setVinirsOpen(!isVinirsOpened);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setSurgeryOpened(false);

    setTeethHealSleepOpened(false);
  };

  const prothesisExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setProthesisOpen(!isProthesisOpened);
    setDiagnosisOpen(false);
    setSurgeryOpened(false);

    setTeethHealSleepOpened(false);
  };

  const teethInSleepExpansion = () => {
    setToothHealOpen(false);
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(false);
    setTeethHealSleepOpened(!isTeethSleepOpened);
    setSurgeryOpened(false);
  };

  const diagnosisExpansion = () => {
    setToothHealingOpen(false);
    setWhiteningOpen(false);
    setMouthHygieneOpen(false);
    setHealingInSleepOpen(false);
    setParodontHealingOpen(false);
    setProthesisOpen(false);
    setDiagnosisOpen(!isDiagnosisOpened);
    setSurgeryOpened(false);
  };

  const customAnimation = keyframes`
  from {
    opacity: 1;
    transform: translate3d(0px, 0px, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-2000, 0, 0);
  }
`;

  // Scrolling Effect
  const [scrollX, setScrollX] = useState<number>(0);
  const [scrollPhotoY, setScrollPhotoY] = useState<number>(0);
  const [bgColor, setBgColor] = useState("#F4F4F4");

  // Menu Function
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuPcOpen, setIsMenuPcOpen] = useState(false);

  const [open, setOpen] = useState(false);

  const [isLarge, setIsLarge] = useState(false);

  // const closeModal = () => setOpen(false);

  const [screenshotOpen, setScreenshotOpen] = useState(false);
  const [currentScreenshot, setCurrentScreenshot] = useState(null);

  const handleOpenScreenshot = (screenshotUrl: any) => {
    setCurrentScreenshot(screenshotUrl);
    setScreenshotOpen(true);
  };

  function openPopupWindow() {
    setOpen(true);
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    window.scrollTo(0, 0);
  };

  const togglePcMenu = () => {
    setIsMenuPcOpen(!isMenuPcOpen);
  };

  const openModal = () => {
    console.log("Opening modal");
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setThankYou(false);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsMenuPcOpen(false);
  };

  useEffect(() => {
    let previousScrollY = 0;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Background Color Transition
      const targetScrollPosition = 800;

      // Gallery Scrolling
      const targetGalleryScrollPosition = 1200;
      let galleryScrollDirection = 0;
      let slowedScroll = scrollPosition;

      // Features Photo Scrolling
      const targetPhotoScrollPosition = 2000;
      let photoScrollDirection = 0;
      let photoSlowedScroll = scrollPosition;

      // Gallery
      if (scrollPosition > previousScrollY) {
        // Scrolling down
        setIsLarge(true);
        galleryScrollDirection = 1;
        photoScrollDirection = 1;
      } else if (scrollPosition < previousScrollY) {
        // Scrolling up
        setIsLarge(false);
        galleryScrollDirection = -1;
        photoScrollDirection = -1;
      }

      // Background Color Transition
      if (scrollPosition >= targetScrollPosition) {
        setBgColor("#202637");
      } else {
        setBgColor("#F4F4F4");
      }

      // Setting slowedScroll
      if (scrollPosition >= targetGalleryScrollPosition) {
        slowedScroll = scrollPosition + galleryScrollDirection / 800;
        setScrollX(slowedScroll);
      }

      if (scrollPosition >= targetPhotoScrollPosition) {
        photoSlowedScroll = scrollPosition + photoScrollDirection;
        setScrollPhotoY(photoSlowedScroll);
      }

      previousScrollY = scrollPosition;
    };

    if (typeof window !== "undefined") {
      console.log(document.title);
    }

    const timer = setTimeout(() => {
      setOpen(true);
    }, 90000);

    window.addEventListener("scroll", handleScroll);

    setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <Layout>
      <div className="screen">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Стоматологические клиники в Ивантеевке. Запишитесь на консультацию
          </title>
          <meta
            property="og:title"
            content="Стоматологические клиники в Ивантеевке. Запишитесь на консультацию"
          ></meta>
          <meta
            property="og:description"
            content="Сеть клиник Dental Home - здоровье зубов и качественное лечение. Запишитесь на прием сейчас"
          ></meta>
          <meta
            name="description"
            content="Сеть клиник Dental Home - здоровье зубов и качественное лечение. Запишитесь на прием сейчас"
          ></meta>
        </Helmet>
        {isLoading ? (
          <Reveal keyframes={customAnimation} delay={1000}>
            <div className={`loader ${isLoading ? "" : "hidden"}`}>
              <div className="loader-container">
                <img className="logo" src={logoMobile} alt="logo"></img>
                <h1 className="loading-heading">
                  Клиника Эстетической Стоматологии
                </h1>
              </div>
            </div>
          </Reveal>
        ) : (
          <div className="all-screen-content">
            <Helmet>
              <meta charSet="utf-8" />
              <title>
                Стоматологические клиники в Ивантеевке. Запишитесь на
                консультацию
              </title>
              <meta
                property="og:title"
                content="Стоматологические клиники в Ивантеевке. Запишитесь на консультацию
"
              ></meta>
              <meta
                property="og:description"
                content="Сеть клиник Dental Home - здоровье зубов и качественное лечение. Запишитесь на прием сейчас"
              ></meta>
              <meta
                name="description"
                content="Сеть клиник Dental Home - здоровье зубов и качественное лечение. Запишитесь на прием сейчас"
              ></meta>
            </Helmet>
            <Mheader
              isMenuOpen={isMenuOpen}
              openModal={openModal}
              toggleMenu={toggleMenu}
            ></Mheader>
            <section className="content">
              <div className="header-container" style={{ width: "100%" }}></div>
              <div className="tablet" style={{ width: "100%" }}>
                <Header
                  isMenuPcOpen={isMenuPcOpen}
                  openModal={openModal}
                  togglePcMenu={togglePcMenu}
                ></Header>
              </div>
              <div className="heading-container">
                <Fade direction="up">
                  <h2 className="dental">Dental</h2>
                  <h2 className="home">Home</h2>
                </Fade>
              </div>
              <img
                className="main_image"
                src={mainPhoto}
                alt="main_image"
              ></img>
            </section>
            <section className="pc-content">
              <div className="white-content">
                <div className="header-container">
                  <Header
                    isMenuPcOpen={isMenuPcOpen}
                    openModal={openModal}
                    togglePcMenu={togglePcMenu}
                  ></Header>
                </div>
                <div className="heading-container">
                  <Fade direction="up" triggerOnce={true}>
                    <h2 className="dental">Dental</h2>
                    <h2 className="home">Home</h2>
                  </Fade>
                </div>
                <div
                  className="blue-content"
                  style={{
                    backgroundColor: bgColor,
                    transition: " background-color 0.5s ease-in-out",
                  }}
                  id="changeColorSection"
                >
                  <div className="photos">
                    <Fade direction="left" delay={400} triggerOnce={true}>
                      <img
                        className={`main_image ${isLarge ? "large" : ""}`}
                        src={mainPC}
                        alt="main"
                      ></img>
                    </Fade>
                    <Fade triggerOnce={true} delay={200}>
                      <div className="photo-container">
                        <img className="bulb" src={bulb} alt="bulb"></img>
                        <img src={pavelPC} alt="pavel" className="pavel"></img>
                        <div className="doctor-names">
                          <span className="name">Главный врач</span>
                          <span className="under-text">
                            Тамаров Павел Сергеевич
                          </span>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>
            <div className="gallery-content" id="gallery">
              <div
                className="pictures-div"
                style={{ transform: `translateX(-${scrollX / 13}px)` }}
              >
                <img
                  className="gallery-05"
                  src={galleryFive}
                  alt="gallery-picture-05"
                ></img>
                <img
                  className="gallery-04"
                  src={galleryFour}
                  alt="gallery-picture-04"
                ></img>
                <img
                  className="gallery-03"
                  src={galleryThree}
                  alt="gallery-picture-03"
                ></img>
                <img
                  className="gallery-02"
                  src={galleryTwo}
                  alt="gallery-picture-02"
                ></img>
                <img
                  className="gallery-01"
                  src={galleryOne}
                  alt="gallery-picture-01"
                ></img>
              </div>
            </div>
            <div className="features-screen" id="features-list-mob">
              <section className="doctor-container">
                <div className="content">
                  <div className="image-container">
                    <img className="bulb" src={bulb} alt="bulb"></img>
                    <img className="image" src={pavel} alt="pavel"></img>
                    <div className="main_doctor">Главный врач</div>
                    <div className="name">Тамаров Павел Сергеевич</div>
                  </div>
                </div>
              </section>
              <section className="features-container">
                <img
                  className="features-photo"
                  src={featuresPhoto}
                  alt="features-photo"
                ></img>
                <div className="features">
                  <div className="divider"></div>
                  <FeatureTab
                    number="01"
                    text="Современная клиника с самым передовым оборудованием"
                  />
                  <div className="divider"></div>
                  <FeatureTab
                    number="02"
                    text="Тщательно соблюдаем санитарные требования и гигиены, что обеспечиваем и контролируем с помощью автоклавов последнего поколения"
                  />
                  <div className="divider"></div>
                  <FeatureTab
                    number="03"
                    text="Используем только качественные и надёжные материалы, подтверждённые российскими и международными сертификатами"
                  />
                  <div className="divider"></div>
                  <FeatureTab
                    number="04"
                    text="Индивидуальный подход к каждому клиенту"
                    goldText="Мы используем самые эффективные и безопасные обезболивающие методики при протезировании и лечении зубов."
                  />
                  <div className="divider"></div>
                  <FeatureTab
                    number="06"
                    text="Медицинское учреждение премиум-класса"
                    goldText="У нас Вы можете воспользоваться широким спектром самых востребованных в современной стоматологии услуг."
                  ></FeatureTab>
                  <div className="text_divider">
                    <div className="divider"></div>
                    <div className="row_text">
                      <span className="paragraph">Наши преимущества</span>
                      <span className="number">07</span>
                    </div>
                  </div>
                  <FeatureLong
                    number="01"
                    text="Удобное расположение"
                  ></FeatureLong>
                  <FeatureLong
                    number="02"
                    text="Домашняя атмосфера"
                  ></FeatureLong>
                  <FeatureLong
                    number="03"
                    text="Все стоматологические процедуры"
                  ></FeatureLong>
                  <FeatureLong
                    number="04"
                    text="Современное оборудование"
                  ></FeatureLong>
                </div>
                <button className="golden-button" onClick={openPopupWindow}>
                  Записаться на прием
                </button>
              </section>
            </div>
            <div className="pc-features-screen" id="features-list-pc">
              <section className="features-content">
                <Fade triggerOnce={true} direction="left">
                  <img
                    className="features-image"
                    src={featuresPhotoPc}
                    style={{
                      // transform: `translateY(${topPosition}px)`,
                      position: "sticky",
                      top: "128px",
                    }}
                    alt="features-photo-pc"
                  ></img>
                </Fade>
                <div className="features-list">
                  <Fade triggerOnce={true} direction="right" delay={100}>
                    <h2 className="features-heading">Преимущества</h2>
                  </Fade>
                  <div className="list-content">
                    <Fade triggerOnce={true} direction="right" delay={200}>
                      <div className="list-01">
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">01</span>
                        </div>
                        <Fade
                          triggerOnce={true}
                          direction="right"
                          delay={300}
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <p className="list-p">
                            Современная клиника с самым передовым оборудованием
                          </p>
                        </Fade>
                      </div>
                    </Fade>
                    <div className="list-02">
                      <Fade triggerOnce={true} direction="right" delay={400}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">02</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={500}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p l">
                          Тщательно соблюдаем санитарные требования и гигиены,
                          что обеспечиваем и контролируем с помощью автоклавов
                          последнего поколения
                        </p>
                      </Fade>
                    </div>
                    <div className="list-02">
                      <Fade triggerOnce={true} direction="right" delay={600}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">03</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={700}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p l">
                          Используем только качественные и надёжные материалы,
                          подтверждённые российскими и международными
                          сертификатами{" "}
                        </p>
                      </Fade>
                    </div>
                    <div className="list-02">
                      <Fade triggerOnce={true} direction="right" delay={800}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">04</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={900}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p">
                          Индивидуальный подход к каждому клиенту{" "}
                        </p>
                      </Fade>
                    </div>
                    <div className="list-02">
                      <Fade triggerOnce={true} direction="right" delay={1000}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">05</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={1100}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p l">
                          Каждый кабинет оснащен современным оборудованием
                          лучших мировых производителей.
                        </p>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={1200}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p-gold">
                          Мы используем самые эффективные и безопасные
                          обезболивающие методики при протезировании и лечении
                          зубов.
                        </p>
                      </Fade>
                    </div>
                    <div className="list-02">
                      <Fade triggerOnce={true} direction="right" delay={1300}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">06</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={800}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p l">
                          Медицинское учреждение премиум-класса
                        </p>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={800}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p-gold">
                          У нас Вы можете воспользоваться широким спектром самых
                          востребованных в современной стоматологии услуг.
                        </p>
                      </Fade>
                    </div>
                    <div className="list-02 squares">
                      <Fade triggerOnce={true} direction="right" delay={800}>
                        <div className="divider-container">
                          <div className="divider"></div>
                          <span className="number">07</span>
                        </div>
                      </Fade>
                      <Fade
                        triggerOnce={true}
                        direction="right"
                        delay={800}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <p className="list-p">Наши преимущества</p>
                      </Fade>
                      <Fade triggerOnce={true} direction="right" delay={800}>
                        <div className="square-row first">
                          <div className="square">
                            <span className="number">01</span>
                            <span className="gold-p">Удобное расположение</span>
                          </div>
                          <div className="square left">
                            <span className="number">02</span>
                            <span className="gold-p">Домашняя атмосфера</span>
                          </div>
                        </div>
                      </Fade>
                      <Fade triggerOnce={true} direction="right" delay={800}>
                        <div className="square-row second">
                          <div className="square ">
                            <span className="number">03</span>
                            <span className="gold-p">
                              Все стоматологические процедуры
                            </span>
                          </div>
                          <div className="square left">
                            <span className="number">04</span>
                            <span className="gold-p">
                              Современное оборудование
                            </span>
                          </div>
                        </div>
                      </Fade>
                    </div>
                    <Fade triggerOnce={true} direction="right" delay={800}>
                      <button className="golden-btn" onClick={openPopupWindow}>
                        Записаться на прием
                      </button>
                    </Fade>
                  </div>
                </div>
              </section>
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "#fff",
                padding: "60px 0",
                boxSizing: "border-box",
              }}
            >
              <section
                style={{
                  maxWidth: "1200px",
                  margin: "0 auto",
                  padding: "0 20px",
                }}
              >
                <Fade triggerOnce={true} direction="up" delay={100}>
                  <h2
                    style={{
                      fontSize: "clamp(28px, 4vw, 36px)",
                      fontWeight: "700",
                      color: "#202637",
                      marginBottom: "40px",
                      textAlign: "center",
                    }}
                  >
                    Акции <span style={{ color: "#E6C96B" }}>Dental Home</span>
                  </h2>
                </Fade>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    maxWidth: "100%",
                  }}
                >
                  {/* Promotion 1 */}
                  <Fade triggerOnce={true} direction="up" delay={200}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Бесплатная консультация
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          0 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            textDecoration: "line-through",
                            marginLeft: "10px",
                          }}
                        >
                          1200 ₽
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Первичная консультация специалиста абсолютно бесплатно
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>

                  {/* Promotion 2 */}
                  <Fade triggerOnce={true} direction="up" delay={300}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Имплантация с пожизненной гарантией
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          от 26900 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            marginLeft: "10px",
                          }}
                        >
                          за один имплант
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Качественная имплантация зубов с пожизненной гарантией
                        от наших специалистов
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>

                  {/* Promotion 3 */}
                  <Fade triggerOnce={true} direction="up" delay={400}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Отбеливание Zoom 4
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          38 000 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            textDecoration: "line-through",
                            marginLeft: "10px",
                          }}
                        >
                          46 200 ₽
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Профессиональное отбеливание зубов с технологией Zoom 4
                        для яркой улыбки
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>

                  {/* Promotion 4 */}
                  <Fade triggerOnce={true} direction="up" delay={500}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Профессиональная гигиена зубов
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          8 200 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            textDecoration: "line-through",
                            marginLeft: "10px",
                          }}
                        >
                          10 400 ₽
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Комплексная гигиена с использованием Air Flow и
                        УльтраЗвука для безупречной чистоты
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>

                  {/* Promotion 5 */}
                  <Fade triggerOnce={true} direction="up" delay={600}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Красивая улыбка за 1 день
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          218 000 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            textDecoration: "line-through",
                            marginLeft: "10px",
                          }}
                        >
                          350 000 ₽
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Комплексное преображение улыбки с использованием
                        современных методик за один день
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>

                  {/* Promotion 6 - Готовимся к школе */}
                  <Fade triggerOnce={true} direction="up" delay={700}>
                    <div
                      style={{
                        padding: "25px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        border: "1px solid rgba(230, 201, 107, 0.3)",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Акция
                      </div>
                      <h3
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#202637",
                          marginBottom: "15px",
                          paddingRight: "80px",
                        }}
                      >
                        Готовимся к школе
                      </h3>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#E6C96B",
                          }}
                        >
                          4 900 ₽
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#777",
                            textDecoration: "line-through",
                            marginLeft: "10px",
                          }}
                        >
                          6 800 ₽
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          marginTop: "5px",
                        }}
                      >
                        Комплексный осмотр + гигиена полости рта для подготовки
                        к учебному году
                      </p>
                      <button
                        onClick={openPopupWindow}
                        style={{
                          marginTop: "15px",
                          padding: "12px 25px",
                          backgroundColor: "#E6C96B",
                          color: "#202637",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          alignSelf: "flex-start",
                          transition: "background-color 0.3s",
                          fontSize: "16px",
                        }}
                      >
                        Записаться
                      </button>
                    </div>
                  </Fade>
                </div>

                {/* View all promotions button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "40px",
                  }}
                >
                  <button
                    onClick={openPopupWindow}
                    style={{
                      padding: "14px 30px",
                      backgroundColor: "transparent",
                      color: "#202637",
                      border: "2px solid #E6C96B",
                      borderRadius: "8px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s",
                      fontSize: "16px",
                    }}
                  >
                    Узнать подробнее об акциях
                  </button>
                </div>
              </section>
            </div>
            <div className="service-screen" id="services">
              <section className="content">
                <div className="service-heading-container">
                  <h2 className="services-heading">
                    Услуги <span className="golden">Dental Home</span>
                  </h2>
                </div>
                <div className="text_divider">
                  <div
                    className="divider"
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.30)" }}
                  ></div>
                  <div className="row_text">
                    <span className="paragraph">Наши преимущества</span>
                  </div>
                </div>
                <div className="services-buttons">
                  <button onClick={toothHealingExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isToothHealingOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Ортопедия
                      </span>
                      <FontAwesomeIcon
                        icon={isToothHealingOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isToothHealingOpened && (
                    <ExpandedTab
                      service_text="Виниры и коронки"
                      link_text="Оттиски"
                      link_text_2="Вкладки"
                      link_text_5="Виниры"
                      link_text_3="Коронки"
                      link_text_4="Восстановление зуба винирами"
                      openModal={openModal}
                      href="/services/vinirs"
                      href_2="/services/vinirs"
                      href_3="/services/teeth-crowns"
                      href_4="/services/tooth-restoration"
                      href_5="/services/vinirs"
                    />
                  )}
                  {/* <button
                  onClick={() => navigate("/services/teeth-healing")}
                  className="btn"
                >
                  <div className="btn-content">
                    <span
                      className={
                        isToothHealingOpened ? "text-active" : "text-inactive"
                      }
                    >
                      Лечение зубов в Ивантеевке
                    </span>
                    <FontAwesomeIcon
                      icon={isToothHealingOpened ? faMinus : faPlus}
                      className="golden-icon"
                    />
                  </div>
                </button>
                {isToothHealingOpened && (
                  <ExpandedTab
                    service_text="Виниры и коронки"
                    link_text="Оттиски"
                    link_text_2="Вкладки"
                    link_text_5="Виниры"
                    link_text_3="Коронки"
                    link_text_4="Восстановление зуба винирами"
                    openModal={openModal}
                    href="/services/vinirs"
                    href_2="/services/vinirs"
                    href_3="/services/teeth-crowns"
                    href_4="/services/tooth-restoration"
                    href_5="/services/vinirs"
                  />
                )} */}
                  <button onClick={whiteningExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isWhiteningOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Анализы и Диагностика
                      </span>
                      <FontAwesomeIcon
                        icon={isWhiteningOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isWhiteningOpened && (
                    <ExpandedTab
                      service_text="Диагностика"
                      link_text="Рентгенология"
                      link_text_2="ОПТГ"
                      link_text_3="КТ (компьютерная томография)"
                      link_text_4="3D снимок полости рта"
                      link_text_5="Прицельный снимок"
                      link_text_6="МРТ зубов"
                      link_text_7="Рентген зубов"
                      link_text_8="ЭКГ"
                      link_text_9="Анализы"
                      openModal={openModal}
                      href="/services/diagnostic"
                      href_2="/services/optg"
                      href_3="/services/teeth-ct"
                      href_4="/services/3d"
                      href_5="/services/scope"
                      href_6="/services/mrt"
                      href_7="/services/xray"
                      href_8="/services/ekg"
                      href_9="/services/analysis"
                    />
                  )}
                  <button onClick={healingInSleepExpansion} className="btn">
                    {" "}
                    <div className="btn-content">
                      <span
                        className={
                          isHealingInSleepOpened
                            ? "text-active"
                            : "text-inactive"
                        }
                      >
                        Лечение зубов
                      </span>
                      <FontAwesomeIcon
                        icon={isHealingInSleepOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isHealingInSleepOpened && (
                    <ExpandedTab
                      service_text="Лечение зубов"
                      link_text="Лечение кариеса"
                      link_text_2="Реставрация зубов"
                      link_text_3="Лечение пульпита зубов"
                      link_text_4="Лечение десен"
                      link_text_5="Установка пломб"
                      openModal={openModal}
                      href="/services/caries-heal"
                      href_2="/services/restoration"
                      href_3="/services/pulpitis-healing"
                      href_4="/services/right-healing"
                      href_5="/services/seal"
                    />
                  )}
                  <button onClick={mouthHygieneExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isMouthHygieneOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Отбеливание
                      </span>
                      <FontAwesomeIcon
                        icon={isMouthHygieneOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isMouthHygieneOpened && (
                    <ExpandedTab
                      service_text="Отбеливание"
                      link_text="Отбеливание"
                      openModal={openModal}
                      link_text_4="Профессиональное отбеливание зубов Amazing White"
                      link_text_5="Профессиональное отбеливание зубов Zoom"
                      href="/services/whitening"
                      href_2="/services/whitening"
                      href_3="/services/whitening"
                      href_4="/services/amazing-white"
                      href_5="/services/zoom-whitening"
                    />
                  )}
                  <button onClick={surgeryExpansion} className="btn">
                    {" "}
                    <div className="btn-content">
                      <span
                        className={
                          isSurgeryOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Хирургия
                      </span>
                      <FontAwesomeIcon
                        icon={isSurgeryOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isSurgeryOpened && (
                    <ExpandedTab
                      service_text="Хирургия"
                      link_text="Хирургия"
                      link_text_2="Удаление зуба"
                      link_text_3="Удаление кисты зуба"
                      link_text_4="Удаление зуба мудрости"
                      openModal={openModal}
                      href="/services/surgery"
                      href_2="/services/teeth-delete"
                      href_3="/services/cyst-delete"
                      href_4="/services/wisdom-tooth-delete"
                    />
                  )}
                  <button onClick={vinirExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isVinirsOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Протезирование
                      </span>
                      <FontAwesomeIcon
                        icon={isVinirsOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isVinirsOpened && (
                    <ExpandedTab
                      service_text="Протезирование"
                      link_text="Протезирование на имплантах"
                      link_text_2="Внутрикостная дентальная имплантация системой"
                      link_text_3="Формирователь десны"
                      link_text_4="Синус-лифтинг"
                      link_text_5="Имплантация под ключ"
                      link_text_6="Имплантация All-on-4 "
                      href="/services/prosthetics"
                      href_2="/services/prosthetics"
                      href_3="/services/prosthetics"
                      href_4="/services/prosthetics"
                      href_5="/services/implants"
                      href_6="/services/allon4"
                    />
                  )}
                  <button onClick={parodontHealthExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isParodontHealingOpened
                            ? "text-active"
                            : "text-inactive"
                        }
                      >
                        Ортодонтия
                      </span>
                      <FontAwesomeIcon
                        icon={isParodontHealingOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isParodontHealingOpened && (
                    <ExpandedTab
                      service_text="Исправление прикуса"
                      link_text="Ортодонтическая коррекция с применением брекет-системы"
                      link_text_2="Металлические брекеты"
                      link_text_3="Дополнительные приспособления"
                      link_text_4="Ретенция"
                      link_text_5="Керамические брекеты"
                      link_text_6="DamonQ"
                      href="/services/braces"
                      href_2="/services/bite-correction"
                      href_3="/services/metal-braces"
                      href_4="/services/retainer"
                      href_5="/services/ceramic-braces"
                      href_6="/services/damnoq"
                    />
                  )}
                  <button onClick={prothesisExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isProthesisOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Профилактика и гигиена
                      </span>
                      <FontAwesomeIcon
                        icon={isProthesisOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isProthesisOpened && (
                    <ExpandedTab
                      service_text="Профилактика и гигиена"
                      link_text="Профилактика и гигиена"
                      link_text_2="Профессиональная чистка зубов"
                      link_text_3="Чистка зубов AirFlow"
                      href="/services/hygiene"
                      href_2="/services/teeth-cleaning"
                      href_3="/services/airflow"
                    />
                  )}
                  <button onClick={teethInSleepExpansion} className="btn">
                    <div className="btn-content">
                      <span
                        className={
                          isTeethSleepOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Лечение зубов во сне
                      </span>
                      <FontAwesomeIcon
                        icon={isTeethSleepOpened ? faMinus : faPlus}
                        className="golden-icon"
                      />
                    </div>
                  </button>
                  {isTeethSleepOpened && (
                    <ExpandedTab
                      service_text="Лечение зубов во сне"
                      link_text="Лечение зубов под наркозом"
                      link_text_2="Лечение зубов под наркозом детское"
                      link_text_3="Лечение зубов под седацией"
                      link_text_4=""
                      link_text_5=""
                      href="/services/healing-in-sleep"
                      href_2="/services/child-sleep"
                      href_3="/services/sedation-heal"
                      href_4=""
                    />
                  )}
                </div>
              </section>
            </div>
            <div className="pc-service-screen" id="services">
              <section className="content">
                <div className="heading-container">
                  <h3 className="heading">
                    Услуги <span className="gold">Dental Home</span>
                  </h3>
                </div>
                <div className="rows">
                  <div className="row-one-c">
                    <div className="row"></div>
                    <span className="text">Название услуги</span>
                  </div>
                  <div className="row-one-c two ">
                    <div className="row"></div>
                    <span className="text">Описание</span>
                  </div>
                </div>
                <div className="services-list-content">
                  <div className="services-list">
                    <button
                      onMouseEnter={toothHealingExpansion2}
                      className="btn"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/teeth-healing"
                          className={
                            isToothHealOpened ? "text-active" : "text-inactive"
                          }
                        >
                          Лечение зубов
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={toothHealingExpansion}
                      className="btn"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/vinirs"
                          className={
                            isToothHealingOpened
                              ? "text-active"
                              : "text-inactive"
                          }
                        >
                          Ортопедия
                        </Link>
                      </div>
                    </button>
                    {/* <button
                    onClick={() => navigate("/services/teeth-healing")}
                    className="btn"
                  >
                    <div className="btn-content">
                      <Link
                        to="/services/teeth-healing"
                        className={
                          isToothHealingOpened ? "text-active" : "text-inactive"
                        }
                      >
                        Лечение зубов
                      </Link>
                    </div>
                  </button> */}
                    <button
                      onMouseEnter={whiteningExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/diagnostic"
                          className={
                            isWhiteningOpened ? "text-active" : "text-inactive"
                          }
                        >
                          Анализы и диагностика
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={mouthHygieneExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/whitening"
                          className={
                            isMouthHygieneOpened
                              ? "text-active"
                              : "text-inactive"
                          }
                        >
                          Отбеливание
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={healingInSleepExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/surgery"
                          className={
                            isHealingInSleepOpened
                              ? "text-active"
                              : "text-inactive"
                          }
                        >
                          Хирургия
                        </Link>
                      </div>
                    </button>
                    <button onMouseEnter={vinirExpansion} className="btn one">
                      <div className="btn-content">
                        <Link
                          to="/services/prosthetics"
                          className={
                            isVinirsOpened ? "text-active" : "text-inactive"
                          }
                        >
                          Протезирование
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={parodontHealthExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/bite-correction"
                          className={
                            isParodontHealingOpened
                              ? "text-active"
                              : "text-inactive"
                          }
                        >
                          Ортодонтия
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={prothesisExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/hygiene"
                          className={
                            isProthesisOpened ? "text-active" : "text-inactive"
                          }
                        >
                          Профилактика и гигиена
                        </Link>
                      </div>
                    </button>
                    <button
                      onMouseEnter={teethInSleepExpansion}
                      className="btn one"
                    >
                      <div className="btn-content">
                        <Link
                          to="/services/healing-in-sleep"
                          className={
                            isTeethSleepOpened ? "text-active" : "text-inactive"
                          }
                        >
                          Лечение зубов во сне
                        </Link>
                      </div>
                    </button>
                  </div>
                  {isToothHealingOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/vinirs"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Виниры и коронки</span>
                        <Link to="/services/vinirs" className="gold-text one">
                          Оттиски
                        </Link>
                        <Link to="/services/vinirs" className="gold-text one">
                          Вкладки
                        </Link>
                        <Link to="/services/vinirs" className="gold-text two">
                          Виниры
                        </Link>
                        <Link
                          to="/services/teeth-crowns"
                          className="gold-text two"
                        >
                          Коронки
                        </Link>
                        <Link
                          to="/services/tooth-restoration"
                          className="gold-text two"
                        >
                          Восстановление зуба винирами{" "}
                        </Link>
                        <Link
                          to="/services/bugel-prothesis"
                          className="gold-text two"
                        >
                          Съемные, бюгельные протезы
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isToothHealOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/teeth-healing"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Лечение зубов</span>
                        <Link
                          to="/services/caries-heal"
                          className="gold-text one"
                        >
                          Лечение кариеса
                        </Link>
                        <Link to="/services/seal" className="gold-text one">
                          Установка пломб
                        </Link>
                        <Link
                          to="/services/restoration"
                          className="gold-text one"
                        >
                          Реставрация зубов
                        </Link>
                        <Link
                          to="/services/pulpitis-healing"
                          className="gold-text two"
                        >
                          Лечение пульпита зубов
                        </Link>
                        <Link
                          to="/services/right-healing"
                          className="gold-text two"
                        >
                          Лечение десен
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isTeethSleepOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/healing-in-sleep"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Лечение зубов во сне</span>
                        <Link
                          to="/services/healing-in-sleep"
                          className="gold-text one"
                        >
                          Лечение зубов во сне
                        </Link>
                        <Link
                          to="/services/child-sleep"
                          className="gold-text one"
                        >
                          Лечение зубов у детей во сне
                        </Link>
                        <Link
                          to="/services/sedation-heal"
                          className="gold-text one"
                        >
                          Лечение зубов под седацией
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isWhiteningOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/diagnostic"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Диагностика</span>
                        <Link to="/services/xray" className="gold-text two">
                          Рентген зубов
                        </Link>
                        <Link to="/services/teeth-ct" className="gold-text two">
                          КТ (компьютерная томография)
                        </Link>
                        <Link to="/services/3d" className="gold-text two">
                          3D снимок полости рта
                        </Link>
                        <Link to="/services/optg" className="gold-text two">
                          ОПТГ
                        </Link>
                        <Link to="/services/scope" className="gold-text two">
                          Прицельный снимок
                        </Link>
                        <Link to="/services/mrt" className="gold-text two">
                          МРТ Зубов
                        </Link>
                        <Link to="/services/ekg" className="gold-text two">
                          ЭКГ
                        </Link>
                        <Link to="/services/analysis" className="gold-text two">
                          Анализы (KDL лаборатория)
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isMouthHygieneOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/whitening"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Отбеливание</span>
                        <Link to="services/whitening" className="gold-text">
                          Отбеливание
                        </Link>
                        <Link
                          to="/services/amazing-white"
                          className="gold-text"
                        >
                          Профессиональное отбеливание зубов Amazing White
                        </Link>
                        <Link
                          to="/services/zoom-whitening"
                          className="gold-text"
                        >
                          Профессиональное отбеливание зубов Zoom
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isHealingInSleepOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/surgery"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Хирургия</span>
                        <Link to="/services/surgery" className="gold-text">
                          Хирургия
                        </Link>
                        <Link to="/services/teeth-delete" className="gold-text">
                          Удаление зуба
                        </Link>
                        <Link to="/services/cyst-delete" className="gold-text">
                          Удаление кисты зуба
                        </Link>
                        <Link
                          to="/services/wisdom-tooth-delete"
                          className="gold-text"
                        >
                          Удаление зуба мудрости
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isVinirsOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/prosthetics"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Протезирование</span>
                        <Link to="/services/prosthetics" className="gold-text">
                          Протезирование на имплантах
                        </Link>
                        <Link to="/services/prosthetics" className="gold-text">
                          Внутрикостная дентальная имплантация системой
                        </Link>
                        <Link to="/services/prosthetics" className="gold-text">
                          Формирователь десны
                        </Link>
                        <Link to="/services/prosthetics" className="gold-text">
                          Синус-лифтинг
                        </Link>
                        <Link to="/services/prosthetics" className="gold-text">
                          Реконструктивное лечение
                        </Link>
                        <Link to="/services/implants" className="gold-text">
                          Имплантация под ключ
                        </Link>
                        <Link to="/services/allon4" className="gold-text">
                          Имплантация All-on-4
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isParodontHealingOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/bite-correction"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Исправление прикуса</span>
                        <Link to="/services/braces" className="gold-text">
                          Ортодонтическая коррекция с применением брекет-системы
                        </Link>
                        <Link to="/services/retainer" className="gold-text">
                          Ретенция
                        </Link>
                        <Link
                          to="/services/bite-correction"
                          className="gold-text"
                        >
                          Дополнительные приспособления
                        </Link>
                        <Link
                          to="/services/ceramic-braces"
                          className="gold-text"
                        >
                          Керамические брекеты
                        </Link>
                        <Link to="/services/damonq" className="gold-text">
                          Брекеты DamonQ
                        </Link>
                        <Link to="/services/metal-braces" className="gold-text">
                          Металлические брекеты
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isProthesisOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <Link
                          className="golden-btn"
                          to="/services/hygiene"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Подробнее
                        </Link>
                        <div className="row"></div>
                        <span className="row-text">Профилактика и гигиена</span>
                        <Link to="/services/hygiene" className="gold-text">
                          Профилактика и гигиена
                        </Link>
                        <Link
                          to="/services/teeth-cleaning"
                          className="gold-text"
                        >
                          Профессиональная чиста зубов
                        </Link>
                        <Link to="/services/airflow" className="gold-text">
                          Чистка зубов Airflow
                        </Link>
                      </div>
                    </Fade>
                  )}
                  {isDiagnosisOpened && (
                    <Fade direction="right">
                      <div className="expanded-tab">
                        <button className="golden-btn">Подробнее</button>
                        <div className="row"></div>
                        <span className="row-text">Лечение зубов во сне</span>
                        <a href="" className="gold-text">
                          Удаление зуба под седацией
                        </a>
                        <a href="" className="gold-text">
                          Удаление зуба под общим наркозом
                        </a>
                        <a href="" className="gold-text">
                          Лечение зубов под седацией
                        </a>
                        <a href="" className="gold-text">
                          Лечение зубов под наркозом у взрослых
                        </a>
                      </div>
                    </Fade>
                  )}
                </div>
              </section>
            </div>
            <div className="mob-information flex justify-center items-center column">
              <h1
                className="custom-heading text-center mt-32"
                style={{ width: "50%" }}
              >
                Стоматологии Dental Home в Ивантеевке
              </h1>
              <p
                className="paragraph text-center mt-16"
                style={{ width: "90%" }}
              >
                Наша команда профессиональных врачей стоматологии готова помочь
                вам восстановить улыбку и уверенность в себе. Мы гарантируем
                максимальный комфорт и безопасность при установке протезов, а
                также оптимальный результат. Наши врачи стоматологии -
                профессионалы своего дела, которые готовы помочь вам сохранить
                здоровье зубов и улыбку на лице.
                <br />
                <br />
                Мы понимаем, что посещение стоматолога может вызывать тревогу и
                беспокойство, поэтому наша команда всегда готова ответить на все
                ваши вопросы и объяснить каждый этап процедуры.
                <br />
                <br />
                Не откладывайте визит к стоматологу на потом! Запишитесь на
                консультацию в Dental Home уже сегодня и получите
                профессиональную помощь в сохранении здоровья зубов и улыбки на
                лице. Мы готовы стать вашим надежным партнером в уходе за
                здоровьем полости рта.
              </p>
            </div>
            <div className="doctors-gallery-screen" id="doctors">
              <section className="content">
                <div className="heading-container-gallery">
                  <h2 className="heading">Наши Специалисты</h2>
                </div>
                <div className="divider"></div>
                <Gallery openModal={openModal} />
              </section>
            </div>
            <div className="doctors-gallery-screen-pc" id="doctors">
              <section className="content">
                <div className="heading-container">
                  <h3 className="heading">Наши специалисты</h3>
                </div>
                <div className="divider"></div>
                <PcGallery openModal={openModal} />
                <div
                  className="divider"
                  style={{ marginTop: "clamp(32px,3.33312vw,128px)" }}
                ></div>
              </section>
            </div>
            <div className="free-form-pc">
              <section className="content">
                <div className="form-container">
                  <div className="free-form-content">
                    <div className="input-content">
                      <h4 className="heading">
                        Что вас ждёт на осмотре у стоматолога:
                      </h4>
                      <div className="icons-text-container">
                        <div className="icons">
                          <div className="tooth-icon-container">
                            <img
                              className="tooth-icon"
                              src={toothIcon}
                              alt="tooth"
                            ></img>
                            <p className="paragraph tooth">
                              Осмотрим полость рта и составим фотопротокол
                            </p>
                          </div>
                          <div className="chair-icon-container">
                            <img
                              className="chair-icon"
                              src={chairIcon}
                              alt="chair"
                            ></img>
                            <p className="paragraph tooth">
                              После тщательного осмотра составим план лечения
                            </p>
                          </div>
                        </div>
                      </div>
                      <span className="text-span">
                        Звоните с 9:00 до 21:00{" "}
                        <strong>+7 (991) 779-39-95</strong> или оставьте заявку,
                        мы вам перезвоним
                      </span>
                      <form
                        className="input-container"
                        ref={phoneForm}
                        onSubmit={sendPhoneRequest}
                      >
                        <input
                          type="tel"
                          name="phoneNumber"
                          value={phoneNumber}
                          className="telephone-input"
                          required={true}
                          onChange={(event) =>
                            setPhoneNumber(event.target.value)
                          }
                          placeholder="+7 (991) 779-39-95"
                        />
                        <button className="form-btn" value="Send">
                          Записать на осмотр
                        </button>
                      </form>
                    </div>
                    <img
                      className="form-image"
                      src={formImage}
                      alt="image"
                    ></img>
                  </div>
                </div>
              </section>
            </div>
            <div className="dental-home-gallery-pc">
              <section className="content">
                <div className="heading-container">
                  <h4 className="heading">Клиники Dental Home </h4>
                </div>
                <div className="galleries-container">
                  <div className="gallery-one">
                    <h6 className="g-heading">
                      Клиника на Советском проспекте, 5
                    </h6>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      loop={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      style={
                        {
                          "--swiper-pagination-color": "#E8CB6C",
                          "--swiper-navigation-color": "#E8CB6C",
                        } as React.CSSProperties
                      }
                      className="mySwiper4"
                    >
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryOnePic}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryTwoPicture}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryThreePicture}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryFourPicture}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryFivePicture}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                  <div className="gallery-two">
                    <h6 className="g-heading">Клиника на Рощинской, 9</h6>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      loop={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      style={
                        {
                          "--swiper-pagination-color": "#E8CB6C",
                          "--swiper-navigation-color": "#E8CB6C",
                        } as React.CSSProperties
                      }
                      className="mySwiper5"
                    >
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={galleryTwoPic}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery02}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery03}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery04}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery05}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery06}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="swiper-image"
                          src={gallery07}
                          alt="image"
                        ></img>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
                <div className="btn-container">
                  <button className="gold-btn" onClick={openPopupWindow}>
                    Записаться на прием
                  </button>
                </div>
              </section>
            </div>
            <div className="dental-home-gallery">
              <section className="content">
                <div className="gallery-heading-container">
                  <h3 className="gallery-heading">Клиники Dental Home</h3>
                </div>
                <div className="divider"></div>
                <div className="galleries">
                  <div className="gallery-one">
                    <h4 className="gallery-heading">
                      Клиника на Советском проспекте, 5
                    </h4>
                    <ClinicGalleryOne></ClinicGalleryOne>
                  </div>
                  <div className="gallery-two">
                    <h4 className="gallery-heading-two">
                      Клиника на Рощинской, 9
                    </h4>
                    <ClinicGalleryTwo></ClinicGalleryTwo>
                  </div>
                </div>
              </section>
            </div>
            <div className="review-pc-screen" id="review">
              <section className="content">
                <div className="heading-container">
                  <h5 className="heading">Отзывы</h5>
                </div>
                <div className="divider"></div>
                <ReviewGalleryDesktop />
                <div className="all-reviews-container">
                  {/* <a className="blue-link">Все отзывы</a> */}
                </div>
              </section>
            </div>
            <div
              className="form-pc-screen"
              id="form-screen"
              ref={form}
              onSubmit={sendEmail}
            >
              <section className="content">
                <div className="heading-container">
                  <h5 className="heading">Записаться На Прием</h5>
                </div>
                <div className="divider"></div>
                <form action="" className="form-content">
                  <div className="row-c">
                    <div className="input-container">
                      <span className="text">Имя*</span>
                      <input
                        type="text"
                        className="input-c"
                        required={true}
                        value={fullName}
                        name="fullName"
                        onChange={(event) => setFullName(event.target.value)}
                        placeholder="Иван Иванов"
                      />
                    </div>
                    <div className="input-container">
                      <span className="text">Телефон*</span>
                      <input
                        type="text"
                        className="input-c"
                        required={true}
                        value={phoneNumber}
                        name="phoneNumber"
                        onChange={(event) => setPhoneNumber(event.target.value)}
                        placeholder="+7 (991) 779-39-95"
                      />
                    </div>
                  </div>
                  <div className="row-c">
                    <div className="input-container services">
                      <span className="text">Услуга</span>
                      <input
                        type="text"
                        placeholder="Выберите Услугу"
                        required={true}
                        value={serviceName}
                        name="serviceName"
                        onChange={(event) => setServiceName(event.target.value)}
                        className="input-s"
                      />
                    </div>
                  </div>
                  <div className="row-c"></div>
                  <div className="row-c">
                    <div className="input-container services">
                      <span className="text">Фамилия врача</span>
                      <input
                        type="text"
                        placeholder="Фамилия врача"
                        required={true}
                        value={doctorName}
                        name="doctorName"
                        onChange={(event) => setDoctorName(event.target.value)}
                        className="input-s"
                      />
                    </div>
                  </div>
                  <div className="row-c">
                    <div className="input-container services">
                      <span className="text">Дата приема</span>
                      <input
                        type="text"
                        placeholder="Дата приема"
                        // ! поменять на bookDate
                        value={bookDate}
                        name="bookDate"
                        onChange={(event) => setBookDate(event.target.value)}
                        className="input-s"
                      />
                    </div>
                  </div>
                  <div className="row-c">
                    <div className="input-container services">
                      <span className="text">Время приема</span>
                      <input
                        type="text"
                        placeholder="Время приема"
                        value={bookTime}
                        name="bookTime"
                        onChange={(event) => setBookTime(event.target.value)}
                        className="input-s"
                      />
                    </div>
                  </div>

                  <div className="row-c">
                    <div className="input-container services">
                      <span className="text">Комментарий</span>
                      <textarea
                        className="comment"
                        name="comment"
                        value={comment}
                        onChange={(event) => setComment(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="checkbox-container">
                    <div className="check-row">
                      <input type="checkbox" className="checkbox" />
                      <span className="text">
                        Ознакомлен с Условиями обработки персональных данных
                      </span>
                    </div>
                    <button className="golden-btn" value="Send">
                      Записаться на прием
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="icon"
                        style={{
                          fontSize: "clamp(6px,0.62496vw,24px)",
                          marginLeft: "clamp(4px,0.41664vw,16px)",
                        }}
                      ></FontAwesomeIcon>
                    </button>
                  </div>
                </form>
              </section>
            </div>
            <div className="review-screen" id="review">
              <section className="content">
                <div className="review-heading-container">
                  <h3 className="reviews-heading">Отзывы</h3>
                </div>
                <div className="divider"></div>
                <ReviewGallery />
                <div className="link-blue-container">
                  <a href="" className="blue-link">
                    Все отзывы
                  </a>
                </div>
              </section>
            </div>
            <div
              className="form-screen"
              id="form-screen-mob"
              ref={form}
              onSubmit={sendEmail}
            >
              <section className="content">
                <div className="form-heading-container">
                  <h3 className="form-heading">Записаться На Прием</h3>
                </div>
                <div className="divider"></div>
                <form action="" className="form">
                  <div className="input-container">
                    <label htmlFor="name" className="la">
                      Имя*
                    </label>
                    <input
                      type="text"
                      required={true}
                      value={fullName}
                      name="fullName"
                      onChange={(event) => setFullName(event.target.value)}
                      className="input-text"
                      placeholder="Иван Иванов"
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="phone" className="la">
                      Номер телефона*
                    </label>
                    <input
                      type="tel"
                      value={phoneNumber}
                      onChange={(event) => setPhoneNumber(event.target.value)}
                      name="phoneNumber"
                      className="input-text"
                      placeholder="+7 (991) 779-39-95"
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="service" className="la">
                      Услуга
                    </label>
                    <input
                      type="text"
                      value={serviceName}
                      onChange={(event) => setServiceName(event.target.value)}
                      name="serviceName"
                      placeholder="Выберите Услугу"
                      className="input-text"
                    />
                  </div>

                  {/* <div className="input-container">
                    <label htmlFor="direction" className="la">
                      Направление
                    </label>
                    <input
                      type="text"
                      name="direction"
                      placeholder="Выберите Направление"
                      className="input-text"
                    />
                  </div> */}
                  <div className="input-container">
                    <label htmlFor="doctor" className="la">
                      Фамилия врача
                    </label>
                    <input
                      type="text"
                      name="doctorName"
                      value={doctorName}
                      onChange={(event) => setDoctorName(event.target.value)}
                      placeholder="Фамилия врача"
                      className="input-text"
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="service" className="la">
                      Дата приема
                    </label>
                    <input
                      type="text"
                      value={bookDate}
                      onChange={(event) => setBookDate(event.target.value)}
                      name="bookDate"
                      placeholder="Дата приема"
                      className="input-text"
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="service" className="la">
                      Время приема
                    </label>
                    <input
                      type="text"
                      value={bookTime}
                      onChange={(event) => setBookTime(event.target.value)}
                      name="bookTime"
                      placeholder="Время приема"
                      className="input-text"
                    />
                  </div>

                  <div className="input-container">
                    <label htmlFor="comment" className="la">
                      Комментарий
                    </label>
                    <textarea
                      name="comment"
                      value={comment}
                      onChange={(event) => setComment(event.target.value)}
                      className="comment"
                    ></textarea>
                  </div>
                  <div className="checkbox-container">
                    <div className="checkbox-container-2">
                      <MDBCheckbox
                        name="flexCheck"
                        value=""
                        id="flexCheckChecked"
                        label="Ознакомлен с Условиями обработки персональных данных"
                        defaultChecked
                      />
                    </div>
                  </div>
                  <button className="form-button" value="Send">
                    Записаться на прием
                    <FontAwesomeIcon
                      className="icon"
                      icon={faChevronRight}
                      style={{
                        fontSize: "clamp(7px,3.2709599999999996vw,28px",
                        marginLeft: "clamp(4px,1.86912vw,16px)",
                      }}
                    ></FontAwesomeIcon>
                  </button>
                </form>
              </section>
            </div>
            <Footer></Footer>
            <Popup
              open={open}
              closeOnDocumentClick
              onClose={closeModal}
              modal
              nested
              className="popup-container"
              position="center center"
              overlayStyle={{
                background: "rgba(32, 38, 55, 0.9)",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                boxSizing: "border-box",
              }}
              contentStyle={{
                background: "transparent",
                border: "none",
                padding: 0,
                margin: 0,
                width: "100%",
                height: "auto",
                maxWidth: window.innerWidth > 768 ? "900px" : "400px",
                overflow: "visible",
              }}
            >
              <div
                className="modal"
                style={{
                  position: "relative",
                  background: "#fff",
                  width: "100%",
                  maxWidth: window.innerWidth > 768 ? "900px" : "380px",
                  margin: "0 auto",
                  display: "flex",
                  flexDirection: window.innerWidth > 768 ? "row" : "column",
                  alignItems: "stretch",
                  borderRadius: "12px",
                  overflow: "hidden",
                  minHeight: window.innerWidth > 768 ? "500px" : "auto",
                }}
              >
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={closeModal}
                  className="gold-cross"
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    fontSize: "24px",
                    color: "#E6C96B",
                    cursor: "pointer",
                    background: "rgba(0,0,0,0.5)",
                    padding: "8px",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 10,
                  }}
                />

                {/* Image Section */}
                <div
                  style={{
                    flex: window.innerWidth > 768 ? "1" : "none",
                    minHeight: window.innerWidth > 768 ? "500px" : "200px",
                    position: "relative",
                  }}
                >
                  <img
                    className="modal-img"
                    src={modalImage}
                    alt="modal-picture"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* Content Section */}
                <div
                  style={{
                    flex: window.innerWidth > 768 ? "1" : "none",
                    padding:
                      window.innerWidth > 768 ? "60px 40px" : "30px 20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    background: window.innerWidth > 768 ? "#fff" : "#202637",
                    color: window.innerWidth > 768 ? "#202637" : "#fff",
                  }}
                >
                  <h3
                    style={{
                      fontSize: window.innerWidth > 768 ? "28px" : "20px",
                      fontWeight: "600",
                      margin: "0 0 15px 0",
                      color: window.innerWidth > 768 ? "#202637" : "#fff",
                    }}
                  >
                    Записаться на консультацию
                  </h3>
                  <p
                    style={{
                      fontSize: window.innerWidth > 768 ? "16px" : "14px",
                      margin: "0 0 10px 0",
                      opacity: "0.9",
                      color: window.innerWidth > 768 ? "#666" : "#fff",
                    }}
                  >
                    Консультация бесплатно
                  </p>
                  <p
                    style={{
                      fontSize: window.innerWidth > 768 ? "14px" : "12px",
                      margin: "0 0 30px 0",
                      opacity: "0.7",
                      color: window.innerWidth > 768 ? "#666" : "#fff",
                    }}
                  >
                    Свяжемся в течение 15 минут
                  </p>

                  <form
                    className="input-container"
                    onSubmit={sendPhoneRequest}
                    style={{
                      width: "100%",
                      maxWidth: window.innerWidth > 768 ? "350px" : "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <input
                      type="tel"
                      name="phoneNumber"
                      className="phone-number-input"
                      placeholder="+7 (991) 779-39-95"
                      required={true}
                      value={phoneNumber}
                      onChange={(event) => setPhoneNumber(event.target.value)}
                      style={{
                        width: "100%",
                        fontSize: "16px",
                        padding:
                          window.innerWidth > 768 ? "15px 20px" : "12px 15px",
                        borderRadius: "8px",
                        border: "2px solid #E6C96B",
                        boxSizing: "border-box",
                        outline: "none",
                        textAlign: "center",
                        background: "#fff",
                        color: "#202637",
                      }}
                      id="phone-number-input"
                      autoComplete="tel"
                      inputMode="tel"
                    />
                    <button
                      className="phone-btn"
                      type="submit"
                      style={{
                        width: "100%",
                        padding:
                          window.innerWidth > 768 ? "18px 25px" : "15px 20px",
                        background: "#E6C96B",
                        color: "#202637",
                        border: "none",
                        borderRadius: "8px",
                        fontWeight: "600",
                        fontSize: window.innerWidth > 768 ? "18px" : "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      <FontAwesomeIcon icon={faPhone} />
                      Хорошо жду звонка
                    </button>
                  </form>
                </div>
              </div>
            </Popup>
            {thankYou && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(32, 38, 55, 0.9)",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    background: "#fff",
                    borderRadius: "12px",
                    width: "100%",
                    maxWidth: window.innerWidth > 768 ? "600px" : "380px",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                    padding:
                      window.innerWidth > 768 ? "60px 40px" : "40px 20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faClose}
                    onClick={closeModal}
                    className="gold-cross"
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "15px",
                      fontSize: "24px",
                      color: "#E6C96B",
                      cursor: "pointer",
                      background: "rgba(32, 38, 55, 0.1)",
                      padding: "8px",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={logoMobile}
                      alt="logotype"
                      style={{
                        maxWidth: window.innerWidth > 768 ? "120px" : "100px",
                        width: window.innerWidth > 768 ? "100px" : "80px",
                        marginBottom: window.innerWidth > 768 ? "30px" : "25px",
                      }}
                    />
                    <h3
                      style={{
                        fontSize: window.innerWidth > 768 ? "28px" : "20px",
                        fontWeight: "600",
                        margin: "0 0 15px 0",
                        color: window.innerWidth > 768 ? "#202637" : "#fff",
                      }}
                    >
                      Спасибо за вашу заявку
                    </h3>
                    <p
                      style={{
                        fontSize: window.innerWidth > 768 ? "18px" : "16px",
                        color: "#666",
                        margin: "0",
                        lineHeight: "1.4",
                      }}
                    >
                      В скором времени мы свяжемся с вами
                    </p>
                  </div>
                </div>
              </div>
            )}
            <Popup
              open={screenshotOpen}
              onClose={() => setScreenshotOpen(false)}
              contentStyle={{ padding: "0", border: "none" }}
              overlayStyle={{ background: "rgba(32, 38, 55, 0.9)" }}
            >
              {currentScreenshot && (
                <img src={currentScreenshot} alt="Screenshot" />
              )}
            </Popup>
          </div>
        )}
      </div>
    </Layout>
  );
}
